export default "__VITE_ASSET__DJ19HOOb__"